import { http } from "@/http";
import { initCsrf } from "@/http/csrf";

export async function getDashboardOverview(params = {}) {
  await initCsrf();
  const { data } = await http.get("/admin/dashboard/overview", { params });
  return data;
}

await initCsrf();
export async function getDashboardFilters(params = {}) {
  const { data } = await http.get("/admin/dashboard/filters", { params });
  return data;
}
